module.exports = __webpack_public_path__ + "img/team_6.9c64d874.png";